import React from "react";
import { CircularProgress } from "@mui/material";

const LoadingSpinner = ({ color = "#fff", width, height }) => {
  return (
    <>
      <CircularProgress sx={{ color, width, height }} />
    </>
  );
};

export default LoadingSpinner;
